import { Canvas } from "@react-three/fiber";
import { useEffect, useState, useRef, useMemo } from "react";
import useAppStore from "../../store/AppStore.js";
import useLiveAvatarStore from "../../store/LiveAvatarStore.js";
import BotClient1 from "../../services/api/BotClient.js";
import sleep from "../../utils/common/sleep.js";
// Note: HeyGen StreamingAvatar import removed - now using LiveAvatar with LiveKit
import { BotConstants } from "../../libs/constants/index.js";
let currentPlaybackMsg = null;
let isAvatarSpeaking = false;
let interrupt = false;
let clearCaption = false;
let lastMessageAt = null;
export default function ModelViewerV3({
  isModelLoading,
  setBotMessagesDisplayed,
}) {
  const [isLoadingSession, setIsLoadingSession] = useState(false);
  const {
    avatar,
    avatarMediaStream,
    isAvatarSpeakingRef,
    interruptRef,
    clearCaptionRef,
    currentPlaybackMsgRef,
    setCurrentPlaybackMsg,
    setInterrupt,
    setClearCaption,
    isAvatarStreamAvailable,
    setShouldPlayAvatarStream,
    setAvatarMediaStream,
    isAvatarLoading,
    setIsAvatarLoading,
    opener,
    avatarSession,
  } = useLiveAvatarStore();
  const videoRef = useRef(null);
  const botClient = useMemo(() => new BotClient1(), []);
  const {
    liveAvatarSessionToken,
    setLiveAvatarSessionToken,
    modelTextInputController,
    modelTextInputStream,
    modelTextInputReader,
    setModelTextInputController,
    setModelTextInputStream,
    setModelTextInputReader,
    setAvatarVideoStream,
    modelCaptionsReader,
    socket,
  } = useAppStore();

  useEffect(() => {
    isAvatarSpeaking = isAvatarSpeakingRef;
    interrupt = interruptRef;
    clearCaption = clearCaptionRef;
    currentPlaybackMsg = currentPlaybackMsgRef;
  }, [
    isAvatarSpeakingRef,
    interruptRef,
    clearCaptionRef,
    currentPlaybackMsgRef,
  ]);

  useEffect(() => {
    if (isAvatarStreamAvailable && avatarSession && !avatarMediaStream && videoRef.current) {
      console.log("Stream is Ready...");
      console.log("ModelViewer : videoRef.current : ", videoRef.current);
      avatarSession.attach(videoRef.current);
      const waitForStream = async () => {
        while (!videoRef.current?.srcObject) {
          // Wait for video element to have a source
          await new Promise((resolve) => setTimeout(resolve, 250));
        }
        console.log("Setting avatarMediaStream : ", videoRef.current.srcObject);
        setAvatarMediaStream(videoRef.current.srcObject);
      };
      waitForStream();
    }
  }, [isAvatarStreamAvailable, avatarMediaStream,avatarSession]);

  useEffect(() => {
    if (videoRef.current && avatarMediaStream) {
      videoRef.current.srcObject = avatarMediaStream;
      videoRef.current.onloadedmetadata = () => {
        setAvatarVideoStream(avatarMediaStream);
        videoRef.current.play();
        isModelLoading(false);
        setIsAvatarLoading(false);
        console.log("Avatar Playing");
      };
    }
  }, [videoRef, avatarMediaStream]);

  // useEffect(() => {
  //   if (socket && avatarMediaStream) socket.emit("initiate-conversation");
  // }, [socket, avatarMediaStream]);

  // useEffect(() => {
  //   if (avatar) {
  //     // avatar.speak({
  //     //   text: "hi",
  //     //   taskType: TaskType.TALK,
  //     //   taskMode: TaskMode.SYNC,
  //     //   task_type: TaskType.TALK,
  //     // });
  //     // modelTextInputController.enqueue(opener);
  //     // const timer = setInterval(async () => {
  //     //   if (Date.now() - lastMessageAt > 100000) {
  //     //     lastMessageAt = Date.now();
  //     //     avatar.speak({
  //     //       text: "uh-huh... Please Continue...",
  //     //       taskType: TaskType.REPEAT,
  //     //       taskMode: TaskMode.SYNC,
  //     //       task_type: TaskType.REPEAT,
  //     //     });
  //     //   }
  //     // }, 10000);
  //     return () => {
  //       // clearInterval(timer);
  //       endSession();
  //     };
  //   }
  // }, [avatar]);

  useEffect(() => {
    if (socket && !modelTextInputController) {
      //* ModelTextInput Stream
      console.log("Registering ModelTextInputController...");
      let stream = new ReadableStream({
        start(controller) {
          setModelTextInputController(controller);
        },
      });
      setModelTextInputStream(stream);
      let reader = stream.getReader();
      setModelTextInputReader(reader);
      return () => {
        modelTextInputController?.close();
        setModelTextInputController(null);
      };
    }
  }, [socket]);

  useEffect(() => {
    (async () => {
      if (modelTextInputReader && avatar) {
        while (true) {
          let { done, value } = await modelTextInputReader.read();
          if (done) {
            console.log("Stream Complete");
            break;
          }
          console.log("modelTextInputReader value : ", value);
          if (value === BotConstants.INTERRUPTION_STR) {
            if (isAvatarSpeaking) {
              // if (avatar) {
              //   avatar.interrupt();
              // }
              setInterrupt(false);
              setClearCaption(true);
            } else setInterrupt(true);
            setCurrentPlaybackMsg(null);
          } else if (value === BotConstants.CLT_INTERRUPTION_STR) {
            console.log("MicVAD : Trigger");
            if (isAvatarSpeaking) {
              console.log("MicVAD : Interrupting");
              // if (avatar) {
              //   avatar.interrupt();
              // }
              setInterrupt(false);
              setClearCaption(true);
            }
          } else {
            setCurrentPlaybackMsg(value);
            setInterrupt(false);
            setClearCaption(false);
            socket.emit("bot-speech-start");
            lastMessageAt = Date.now();
            // Use LiveAvatar SDK to make avatar speak
            // if (avatar) {
            //   avatar.speak({ text: value });
            // }
            displayMessage(value);
          }
        }
      }
    })();
  }, [modelTextInputReader, avatar]);

  useEffect(() => {
    (async () => {
      if (modelCaptionsReader /* && avatar */) {
        while (true) {
          let { done, value } = await modelCaptionsReader.read();
          if (done) {
            console.log("Stream Complete");
            break;
          }
          if (value === BotConstants.CLEAR_BOT_CAPTIONS_STR) {
            console.log("Clearing Captions...")
            setBotMessagesDisplayed([]);
          } else {
            await displayMessage(value);
          }
        }
      }
    })();
  }, [modelCaptionsReader]);

  async function endSession() {
    await avatar?.stopAvatar();
    setAvatarMediaStream(null);
  }

  async function displayMessage(message) {
    for (let i = 0; i < message.length; i++) {
      if (clearCaption) break;
      setBotMessagesDisplayed((prev) => [...prev, message[i]]);
      if (message[i].includes(" ")) await sleep(100);
      else await sleep(20);
    }
    if (clearCaption) {
      setClearCaption(false);
    }
  }

  return (
    <video
      ref={videoRef}
      autoPlay
      playsInline
      style={{
        // position: "absolute",
        // top: "10px",
        // left: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover", // Prevents cropping, shows the full video content
      }}
    ></video>
  );
}
